import { useEffect } from "react";

const AppRedirect = () => {
  useEffect(() => {
    const userAgent =
      navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
      window.location.href =
        "https://play.google.com/store/apps/details?id=com.maamaas.app";
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      window.location.href =
        "https://apps.apple.com/us/app/maamaas/id6759244693";
    } else {
      window.location.href = "https://maamaas.com";
    }
  }, []);

  return (
    <div style={{ textAlign: "center", marginTop: "100px" }}>
      <h2>Redirecting to App Store...</h2>
    </div>
  );
};

export default AppRedirect;